interface IconProps {
	className?: string;
}

/** Compass / star-chart crosshair */
export function ExploreIcon({ className }: IconProps) {
	return (
		<svg
			className={className}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<circle cx="12" cy="12" r="9" />
			<path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
			{/* 4-pointed star center */}
			<path d="M12 9l1.5 2.25L12 15l-1.5-2.25z" fill="currentColor" stroke="none" />
			<path d="M9 12l2.25-1.5L15 12l-2.25 1.5z" fill="currentColor" stroke="none" />
		</svg>
	);
}

/** Hexagonal dock / hangar bay */
export function ShipyardIcon({ className }: IconProps) {
	return (
		<svg
			className={className}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			{/* Hexagon outline */}
			<path d="M12 2l8.66 5v10L12 22l-8.66-5V7z" />
			{/* Ship chevron */}
			<path d="M8 12h7M15 12l-3.5-3M15 12l-3.5 3" />
		</svg>
	);
}

/** Diamond waypoint / mission objective */
export function MissionsIcon({ className }: IconProps) {
	return (
		<svg
			className={className}
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			{/* Diamond shape */}
			<path d="M12 3l7 9-7 9-7-9z" />
			{/* Center dot */}
			<circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
			{/* Crosshair ticks */}
			<path d="M12 7v2M12 15v2M8.5 12h2M13.5 12h2" strokeWidth="1" />
		</svg>
	);
}
